<script lang="ts">
  import type { Route } from '../../stores/router';
  import { navigate } from '../../stores/router';

  interface Props {
    icon: string;
    title: string;
    description: string;
    route: Route;
    color: string;
    tags?: string[];
    disabled?: boolean;
  }

  let { icon, title, description, route, color, tags = [], disabled = false }: Props = $props();

  function handleClick() {
    if (!disabled) navigate(route);
  }

  function handleKeydown(e: KeyboardEvent) {
    if (!disabled && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      navigate(route);
    }
  }
</script>

<button
  onclick={handleClick}
  onkeydown={handleKeydown}
  class="tool-card group text-left w-full bg-bg-card border border-border rounded-xl p-5 transition-all duration-300 ease-out focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent {disabled ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer hover:-translate-y-1'}"
  style="--card-color: {color}"
  aria-label="{disabled ? title + ' (unavailable)' : 'Open ' + title}"
  aria-disabled={disabled}
>
  <span class="text-[32px] leading-none block mb-3" role="img" aria-hidden="true">{icon}</span>
  <h3 class="text-text-primary font-semibold text-sm mb-1.5">{title}</h3>
  <p class="text-text-secondary text-xs leading-relaxed mb-3">{description}</p>
  {#if tags.length > 0}
    <div class="flex flex-wrap gap-1.5">
      {#each tags as tag}
        <span class="text-[10px] px-2 py-0.5 rounded-full border border-border-light text-text-muted bg-bg-dark/50">{tag}</span>
      {/each}
    </div>
  {/if}
</button>

<style>
  .tool-card:hover:not([aria-disabled="true"]) {
    border-color: var(--card-color);
    box-shadow: 0 8px 24px -4px color-mix(in srgb, var(--card-color) 25%, transparent),
                0 0 0 1px color-mix(in srgb, var(--card-color) 15%, transparent);
  }
</style>
